import { msToTime } from "./DateTime"

export const timeDiff = (firstTime: Date, secondTime: Date) => {
    return msToTime(Date.parse(String(firstTime)) - Date.parse(String(secondTime)))
}